import React, { useState, useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Avatar, Icon } from '@material-ui/core';

import useStyles from './styles';

const Details = ({ id }) => {
  const classes = useStyles();
  const professionalData = useSelector(
    state => state.appointments.professionals.list[id],
  );
  const [professional, setProfessional] = useState({});

  useEffect(() => {
    if (professionalData) {
      setProfessional(professionalData);
    }
  }, [professionalData]);

  return (
    <Box className={classes.container}>
      <Avatar className="details-avatar-container">
        <Icon>person</Icon>
      </Avatar>
      <Box className="details-infos-container">
        <Typography className="details-name" variant="body1">
          {professional?.name}
        </Typography>
        <Typography className="details-area" variant="caption">
          {professional?.areaName}
        </Typography>
        <Box className="details-section-container">
          <Typography className="details-section-label" variant="caption">
            Sobre o profissional:
          </Typography>
          <Typography className="details-section-description" variant="body2">
            {professional?.describe}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
export default memo(Details);
